export interface IErrorLoggingService {
  logError(error: Error, componentStack: string): Promise<any>;
}
interface IInputs {
  baseUrl: string;
}

export class ErrorLoggingService implements IErrorLoggingService {
  baseUrl: string;

  constructor({ baseUrl }: IInputs) {
    this.baseUrl = baseUrl;
  }

  async logError(error: Error, componentStack: string): Promise<any> {
    console.log(error);
    const res = await fetch(`${this.baseUrl}api/v1/logentries/`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
      body: JSON.stringify({
        applicationName: window.spConfig.applicationName,
        componentName: componentStack,
        level: 'Error',
        message: error.message,
      })
    });
    return await res.json();
  }
}

export function genericErrorLogger(error: Error, componentStack: string): void {
  const errorLogger = new ErrorLoggingService({
    baseUrl: window.spConfig.errorLoggerBaseUrl
  });
  errorLogger.logError(error, componentStack);
}
